import { makeFetchCall } from '@next-app/utils/fetch-data';
import urlMapping from '@next-app/config/urlMapping';

let cachedInitResp: any = null;

async function getInitData(cacheType?: string) {
  if (cachedInitResp) {
    return cachedInitResp;
  }

  const uri = `${urlMapping.initUrl}`;
  const cache = cacheType;
  const initResp = await makeFetchCall({
    endpoint: uri,
    cache,
  });

  cachedInitResp = initResp; // Cache the response
  return initResp;
}

export function clearCachedInitData() {
  cachedInitResp = null;
}

export default getInitData;
